import { isNaN } from 'lodash';
import { useEffect, useCallback } from 'react';
import { roundNumberToStringWithDecimals } from '../../../../utils';
import { FocusElement } from '../../../../helpers/focusElement';

export default function useSetup({ decimals }) {
  const handleKeyEvent = useCallback(
    (target) => {
      const selectedAnswerElement = $(target);
      const selectedAnswerValue = roundNumberToStringWithDecimals(
        selectedAnswerElement.val(),
        decimals,
      );
      const answerId = selectedAnswerElement.attr('data-answer-id');
      const answerElement = $(
        `.answerMatrixVanWestendorp[data-answer-id=${answerId}]`,
      );

      const selectedLabel = answerElement.find(
        `.matrix__selected-answer[data-answer-id=${answerId}]`,
      );

      if ($(selectedLabel).text() !== selectedAnswerElement.val()) {
        answerElement
          .find('.matrix__labels span')
          .removeClass('matrix__selected-answer--active');
      }

      $(selectedLabel).text(selectedAnswerValue);
    },
    [decimals],
  );
  const handleChange = useCallback(
    (target) => {
      const selectedAnswerElement = $(target);
      const selectedAnswerValue = roundNumberToStringWithDecimals(
        selectedAnswerElement.val(),
        decimals,
      );

      if (isNaN(parseFloat(selectedAnswerValue))) {
        return;
      }

      $(target).val(selectedAnswerValue);
      const answerId = selectedAnswerElement.attr('data-answer-id');
      const answerElement = $(
        `.answerMatrixVanWestendorp[data-answer-id=${answerId}]`,
      );
      const answersContainer = answerElement.find('.matrix__answers');

      const selectedLabel = answerElement.find(
        `.matrix__selected-answer[data-answer-id=${answerId}]`,
      );

      $(selectedLabel).text(selectedAnswerValue);
      answerElement
        .find('.matrix__labels span')
        .removeClass('matrix__selected-answer--active');
      selectedLabel.addClass('matrix__selected-answer--active');
      answersContainer.addClass('matrix__answers--closed').slideUp();
      $(`.matrix[data-answer-id=${answerId}]`).addClass('matrix--closed');
    },
    [decimals],
  );

  useEffect(() => {
    // eslint-disable-next-line func-names
    $('.input-van-westendorp').each(function() {
      const currentElement = $(this);
      const otherElement = $(currentElement).closest(
        '.answerMatrixVanWestendorp',
      );
      FocusElement(currentElement, otherElement);
    });
  }, []);

  useEffect(() => {
    $('#wrapper').on('keyup', '.input-van-westendorp', (e) => {
      e.preventDefault();
      handleKeyEvent(e.target);
    });

    $('#wrapper').on('blur', '.input-van-westendorp', (e) => {
      e.preventDefault();
      // it is possible respondent to click in the question answer element
      // so we disable the expand/collapse momentarily on the question answer element
      // to avoid the collapse by blur and the expand by the click
      $('#wrapper').off('tap', '.matrix__question', toggleQuestionCollapse);
      handleChange(e.target);
      // we enable again the expand/collapse on the question answer element
      setTimeout(() => {
        $('#wrapper').on('tap', '.matrix__question', toggleQuestionCollapse);
      }, 200);
    });

    $('#wrapper').on('tap', '.matrix__question', toggleQuestionCollapse);

    return () => {
      $('#wrapper').off('keyup', '.input-van-westendorp');
      $('#wrapper').off('blur', '.input-van-westendorp');
      $('#wrapper').off('tap', '.matrix__question');
      $('#wrapper').off('tap', '.matrix__question');
    };
  }, [handleChange, handleKeyEvent]);
}

function toggleQuestionCollapse(e) {
  e.preventDefault();
  const target = $(e.target)
    .parents('.answerMatrixVanWestendorp')
    .attr('data-answer-id');
  const answersDiv = $(`.matrix__answers[data-answer-id=${target}]`);
  const matrix = $(`.matrix[data-answer-id=${target}]`);

  if (answersDiv.hasClass('matrix__answers--closed')) {
    answersDiv.removeClass('matrix__answers--closed').slideDown();
    matrix.removeClass('matrix--closed');
  } else {
    answersDiv.addClass('matrix__answers--closed').slideUp();
    matrix.addClass('matrix--closed');
  }
}
